module.exports = {
	"projects": [
		{
			"id": "009010",
			"symbol": "Squarespace Homepage",
			"brand": "SQUARESPACE",
			"role": "Lead Developer",
			"videoSourceMP4": "/assets/videos/squarespace_home_2019.mp4",
			"videoWidth": 1500,
			"videoHeight": 1000,
			"season": "AW 019",
			"offsetLeft": 1,
			"offsetRight": 1,
			"col": 9,
			"description": "In 2019 I was the Lead Developer on the new Squarespace Homepage</br> Applying our new branding and Building the page and the main carousel was an interesting challenge. It was a real team effort with the FrontSite Team: Brandon, Crystal, Robyn and Cody. As part of this project we also build a brand new styleguide for all of Squarespace.com",
			"agency": "Squarespace",
			"dev": "HTML5, Squarespace, Custom Framework",
			"link": {
				"label": "Visit Website ¬",
				"url": "https://sqsp-homepage-2019.netlify.app/"
			}
		},
		{
			"container": true,
			"id": "container486",
			"children": [
				{
					"id": "765765",
					"symbol": "David William Baum Portfolio",
					"brand": "David William Baum PHOTOGRAPHER",
					"role": "Developer & Interaction Designer",
					"videoSourceMP4": "/assets/videos/david_baum_flow_folio.mp4",
					"videoWidth": 1500,
					"videoHeight": 1000,
					"strokeColor": "#C5C5C5",
					"season": "AW 019",
					"offsetLeft": 0,
					"col": 7,
					"description": "David William Baum is a fashion, still life, and landscape photographer and creative director working out of New York, Los Angeles, and San Francisco.<br/> We tried to provide a simple canvas that highlights the quality of his work. His new website explores contrasts of scale as its primary theme. All the imagery is mixed up, small and unorganized, but as you head deeper into the site, content becomes larger and more structured. Commercial Type’s Styrene, an intentionally awkward sans serif family with wider ‘A’ and narrower ‘B’ versions, adds a clean, geometric quality and provides an anchor for the kinetic imagery.",
					"agency": "Personal",
					"dev": "Interactive, Motion, Transitions, GSAP, responsive, Custom Framework",
					"link": {
						"label": "Visit Website ¬",
						"url": "https://www.davidwilliambaum.com/"
					}
				},
				{
					"id": "image01",
					"image": true,
					"imageSource": "/assets/images/dwb.jpg",
					"offsetLeft": 2,
					"offsetRight": 0,
					"col": 3
				}
			]
		},
		{
			"id": "242343",
			"symbol": "Waka Waka",
			"brand": "WAKAWAKA",
			"role": "Developer & Interaction Designer",
			"videoSourceMP4": "/assets/videos/waka_flow.mp4",
			"videoWidth": 1500,
			"videoHeight": 1000,
			"season": "SS 020",
			"offsetLeft": 4,
			"offsetRight": 0,
			"col": 8,
			"description": "Waka Waka, The Full Collection. Shin Okuda’s selected works of hand-craft wood furniture & functional objects.",
			"agency": "Personal",
			"dev": "HTML5, WEBGL, Custom Framework, Animations",
			"link": {
				"label": "Visit Website ¬",
				"url": "https://wakawaka.world/"
			}
		},
		{
			"id": "00900",
			"symbol": "Vincent Tavano",
			"brand": "VINCENT TAVANO",
			"role": "Developer & Interaction Designer",
			"videoSourceMP4": "/assets/videos/vince.mp4",
			"videoWidth": 1100,
			"videoHeight": 630,
			"season": "SS 018",
			"offsetLeft": 1,
			"offsetRight": 1,
			"col": 10,
			"description": "Had a blast working with my friend Vincent to build is new portfolio. </br> I was in charge of the coding and interaction design. </br> Have fun exploring the website!",
			"agency": "Personal",
			"awards": "awwwards",
			"dev": "PixiJS, Physics, Canvas, audio, animations, Custom Framework, Static site",
			"link": {
				"label": "Visit Website ¬",
				"url": "https://www.tavanovincent.com"
			}
		},
		{
			"container": true,
			"id": "container4234234",
			"children": [
				{
					"id": "image01",
					"image": true,
					"imageSource": "/assets/images/jackjack.jpg",
					"offsetLeft": 0,
					"offsetRight": 1,
					"col": 3
				},
				{
					"id": "2342453",
					"symbol": "Jack Davison Portfolio",
					"brand": "JACK DAVISON PHOTOGRAPHER",
					"role": "Developer & Interaction Designer",
					"videoSourceMP4": "/assets/videos/jack.mp4",
					"videoWidth": 1366,
					"videoHeight": 800,
					"strokeColor": "#C5C5C5",
					"season": "AW 018",
					"offsetLeft": 0,
					"col": 7,
					"description": "Portfolio for the talented photographer Jack Davison. <br />The goal was to have a really minimal site, putting the work of Jack and his photos at the center of the experience.<br />The navigation is simple and the use of motion allow us to create a flow and a narrative between each series.<br />Art Direction by Vincent Tavano. Code & Motion by myself.",
					"agency": "Personal",
					"awards": "site inspire",
					"dev": "Interactive, Motion, Transitions, GSAP, responsive, Custom Framework, Redux",
					"link": {
						"label": "Visit Website ¬",
						"url": "https://www.jackdavison.co.uk"
					}
				}
			]
		},
		{
			"id": "3443",
			"symbol": "Squarespace Circle",
			"brand": "SQUARESPACE CIRCLE",
			"role": "Lead Developer & Interaction Designer",
			"videoSourceMP4": "/assets/videos/circle.mp4",
			"videoWidth": 1366,
			"videoHeight": 800,
			"season": "SS 018",
			"offsetLeft": 3,
			"offsetRight": 1,
			"col": 8,
			"description": "I was in charge of the engineering team that rebuilt Squarespace Circle website. <br/ > Working closely with designers and developers to give Circle a new life. <br /> Circle is a partner program that helps creative professionals launch and scale their Squarespace web design businesses. ",
			"agency": "Personal",
			"awards": "site inspire",
			"dev": "Interactive, Motion, Transitions, GSAP, responsive, Squarespace Dev Platform",
			"link": {
				"label": "Visit Website ¬",
				"url": "https://circle.squarespace.com/"
			}
		},
		{
			"id": "232",
			"symbol": "Andy H Wei",
			"brand": "Andy H Wei | Artist Portfolio",
			"role": "Lead Developer & Interaction Designer",
			"videoSourceMP4": "/assets/videos/andy.mp4",
			"videoWidth": 1366,
			"videoHeight": 800,
			"season": "SS 018",
			"offsetLeft": 3,
			"offsetRight": 1,
			"col": 8,
			"description": "I was in charge of the engineering team that rebuilt Squarespace Circle website. <br/ > Working closely with designers and developers to give Circle a new life. <br /> Circle is a partner program that helps creative professionals launch and scale their Squarespace web design businesses. ",
			"agency": "Personal",
			"awards": "site inspire",
			"dev": "Interactive, Motion, Transitions, GSAP, responsive, Squarespace Dev Platform",
			"link": {
				"label": "Visit Website ¬",
				"url": "http://andyweiart.com/"
			}
		},
		{
			"id": "98878",
			"symbol": "Squarespace",
			"brand": "Squarespace Timeline & Keanu Site",
			"role": "Developer",
			"videoSourceMP4": "/assets/videos/timeline.mp4",
			"videoWidth": 1366,
			"videoHeight": 800,
			"season": "SS 018",
			"offsetLeft": 3,
			"offsetRight": 1,
			"col": 8,
			"description": "I was in charge of the engineering team that rebuilt Squarespace Circle website. <br/ > Working closely with designers and developers to give Circle a new life. <br /> Circle is a partner program that helps creative professionals launch and scale their Squarespace web design businesses. ",
			"agency": "Personal",
			"awards": "site inspire",
			"dev": "Interactive, Motion, Transitions, GSAP, responsive, Squarespace Dev Platform",
			"link": {
				"label": "Visit Website ¬",
				"url": "https://www.squarespace.com/about/timeline"
			}
		},
		{
			"id": "11111",
			"symbol": "Squarespace Prototypes",
			"brand": "Squarespace Prototypes",
			"role": "Developer & Interaction Designer",
			"videoSourceMP4": "/assets/videos/prototypes.mp4",
			"videoWidth": 1366,
			"videoHeight": 800,
			"season": "SS 018",
			"offsetLeft": 3,
			"offsetRight": 1,
			"col": 8,
			"description": "A serie of various prototypes made at Squarespace. <br /> The prototypes folow and highlight different subject:  <br/ >Galleries, Image manipulation, Motion etc...  <br/ > ",
			"agency": "Personal",
			"awards": "site inspire",
			"dev": "Shaders, Physics, Motion, Squarespace",
			"link": {
				"label": "Visit Website ¬",
				"url": "https://circle.squarespace.com/"
			}
		},
		{
			"id": "00",
			"symbol": "Alexandre Rochet",
			"brand": "ALEXANDRE ROCHET",
			"role": "Developer & Interaction Designer",
			"videoSourceMP4": "/assets/videos/alex.mp4",
			"videoWidth": 851,
			"videoHeight": 500,
			"season": "SS 016",
			"offsetLeft": 1,
			"offsetRight": 2,
			"col": 8,
			"description": "Had a blast working with my friend Alexandre to build is new portfolio. </br> I was in charge of the coding and interaction design. There is a lot of details in the motion, like the parallax on the homepage, the spring physic of the menu, the animation of the letters or the displacement map applied to his Alex's face... </br> Have fun exploring the website!",
			"agency": "Stink Studios",
			"dev": "Css animation, Homemade framework",
			"awards": "FWA, awwwards",
			"link": {
				"label": "Visit Website ¬",
				"url": "http://alexandrerochet.com"
			}
		},
		{
			"id": "01",
			"symbol": "Google Pride",
			"brand": "Google",
			"role": "Developer",
			"name": "Google Pride",
			"videoSourceMP4": "/assets/videos/pride.mp4",
			"videoWidth": 1024,
			"videoHeight": 562,
			"season": "SS 017",
			"offsetLeft": 2,
			"offsetRight": 0,
			"col": 8,
			"description": "I had the chance to Stink Studios & Google to design a platform to celebrate and promote Pride from all over the World. Because we all have a reason to #ShowUp..",
			"agency": "Stink Studios",
			"dev": "ES6, Redux, Interactive",
			"link": {
				"label": "Visit Website ¬",
				"url": "https://pride.google/en-US"
			}
		},
		{
			"id": "03",
			"symbol": "The Hidden Worlds of the National Parks",
			"brand": "Google",
			"role": "Developer",
			"name": "Google Parks",
			"videoSourceMP4": "/assets/videos/parks.mp4",
			"videoWidth": 834,
			"videoHeight": 502,
			"season": "AW 016",
			"offsetLeft": 5,
			"offsetRight": 0,
			"col": 7,
			"description": "An interactive tour of America’s most beautiful national parks. Follow rangers on an immersive adventure through five National Parks. Rappel into a crevasse, fly with thousands of bats, soar over an active volcano, dive through shipwrecks, and experience the Milky Way in 360° video and ambisonic audio.",
			"agency": "Stink Studios",
			"dev": "React, ThreeJS, 360 videos, 4 custom modules",
			"link": {
				"label": "Visit Website ¬",
				"url": "https://artsandculture.withgoogle.com/en-us/national-parks-service"
			}
		},
		{
			"id": "04",
			"symbol": "Spotify: Inside Discovery",
			"brand": "PITCHFORK & SPOTIFY",
			"role": "Lead Developer & UX Designer",
			"season": "SS 016",
			"videoSourceMP4": "/assets/videos/spotify_pitchfork.mp4",
			"videoWidth": 831,
			"videoHeight": 500,
			"offsetLeft": 2,
			"offsetRight": 2,
			"col": 8,
			"description": "We worked together with Pitchfork and Spotify to create Inside Discovery. A editorial interactive website that let user have a look into fresh Discover Weekly playlists from Pitchfork editors and their favorite artists.",
			"agency": "Stink Studios",
			"dev": "Css animation, Homemade framework",
			"awards": "FWA, awwwards",
			"link": {
				"label": "Visit Website ¬",
				"url": "http://insidediscovery.pitchfork.com/"
			}
		},
		{
			"container": true,
			"id": "container03",
			"children": [
				{
					"id": "05",
					"symbol": "Twitter MTC",
					"videoSourceMP4": "/assets/videos/mtc.mp4",
					"videoWidth": 853,
					"videoHeight": 486,
					"season": "AW 016",
					"offsetLeft": 1,
					"col": 6,
					"brand": "Twitter",
					"role": "Prototypes Developer, UX & Motion",
					"description": "We partnered with Twitter to prototype and design a new platform full of inspiration, solutions and tools to help marketers and agencies capitalize on the power of Twitter. Was really interesting to work closely with Designer and be part of the Sprints",
					"agency": "Stink Studios",
					"dev": "Design Guideline, Full HTML & Motion design prototypes",
					"link": {
						"label": "Case study ¬",
						"url": "https://www.behance.net/gallery/41645265/Twitter-Marketing-Platform"
					}
				},
				{
					"id": "image01",
					"image": true,
					"imageSource": "/assets/images/flower.jpg",
					"offsetLeft": 1,
					"offsetRight": 0,
					"col": 3
				}
			]
		},
		{
			"id": "06",
			"symbol": "Stink Studios",
			"brand": "New Portfolio",
			"videoSourceMP4": "/assets/videos/sd.mp4",
			"videoWidth": 852,
			"videoHeight": 502,
			"offsetLeft": 3,
			"offsetRight": 0,
			"col": 8,
			"season": "AW 016",
			"role": "Creative/Front-end Developer",
			"description": "In 2016 we launched the new version on StinkDigital portfolio, now called Stink Studios : A global creative studio for a digital-first world.",
			"agency": "Stink Studios",
			"dev": "Isomorphic Rendering, gradient shader, custom Lazy loading, fast page : 2mo desktop, 1mo mobile",
			"link": {
				"label": "Visit Website ¬",
				"url": "http://www.stinkstudios.com"
			}
		},
		{
			"id": "07",
			"brand": "Spotify",
			"symbol": "Found them first",
			"videoSourceMP4": "/assets/videos/ftf.mp4",
			"videoWidth": 852,
			"videoHeight": 502,
			"offsetLeft": 3,
			"offsetRight": 0,
			"col": 7,
			"season": "AW 016",
			"role": "Developer",
			"description": "This is the second in a series of B-Sides data experiments for Spotify. <br/>Found Them First compares your individual Spotify listening history to global data in order to reveal just how many artists you discovered before the tidal wave of mainstream acceptance hit.",
			"agency": "Stink Studios & ",
			"dev": "PixiJS",
			"link": {
				"label": "Case study ¬",
				"url": "http://spotifyftf.timroussilhe.com/"
			}
		},
		{
			"id": "08",
			"symbol": "Il etait une foret",
			"brand": "Luc Jacquet",
			"name": "Il etait une foret",
			"videoSourceMP4": "/assets/videos/ieuf.mp4",
			"videoWidth": 831,
			"videoHeight": 500,
			"offsetLeft": 1,
			"offsetRight": 0,
			"col": 8,
			"season": "AW 014",
			"role": "Lead Developer",
			"description": "Immerse yourself in an expedition to the heart of the tropical primary forests. In the footsteps of the team of the film, discover this incredible universe and learn to detect its codes.",
			"agency": "Freelance",
			"link": {
				"label": "Visit the website ¬",
				"url": "http://iletaituneforet.timroussilhe.com/"
			}
		},
		{
			"container": true,
			"id": "container04",
			"children": [
				{
					"id": "image02",
					"image": true,
					"imageSource": "/assets/images/beauty.jpg",
					"offsetLeft": 1,
					"offsetRight": 1,
					"col": 3
				},
				{
					"id": "09",
					"symbol": "WWF 40 Years Anniversary",
					"brand": "WWF",
					"name": "40 Years",
					"videoSourceMP4": "/assets/videos/wwf.mp4",
					"videoWidth": 852,
					"videoHeight": 504,
					"offsetLeft": 1,
					"offsetRight": 0,
					"col": 6,
					"role": "UX Designer",
					"description": "We partnered with WWF to laucnh an interactive website showcasing 40 Years of Commitment to the Planet",
					"agency": "Freelance",
					"link": {
						"label": "Visit the website ¬",
						"url": "http://40.wwf.fr/fr"
					}
				}
			]
		},
		{
			"id": "10",
			"symbol": "What are you made of? ",
			"brand": "Far Cry 4",
			"videoSourceMP4": "/assets/videos/farcry.mp4",
			"videoWidth": 852,
			"videoHeight": 504,
			"offsetLeft": 2,
			"offsetRight": 2,
			"col": 8,
			"season": "AW 014",
			"role": "Developer",
			"description": "What are you made of ? is a rich and mind-bending interactive film experience for the launch of Far Cry 4. Reveal your personality through 4 rites where every decision you make changes the course of the experience!.",
			"agency": "Stink Studios Paris",
			"dev": "ThreeJS, custom video modules, binaural sounds"
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Works/projects.json
 ** module id = 252
 ** module chunks = 0
 **/